import { DEFAULT_LOCALE, UserLocale } from '@/shared/config';

const LOCALE_ALIASES: Record<string, UserLocale> = {
  en: DEFAULT_LOCALE,
};

export const normalizeLocale = (
  locale: UserLocale = DEFAULT_LOCALE,
): UserLocale => LOCALE_ALIASES[locale] ?? locale;
